import { connect } from 'react-redux';
import { newSuccessNotification } from '../../components/common/redux/actions/notificationActions';
import Component from './component';

const mapDispatchToProps = {
  successNotification: newSuccessNotification,
};

export default connect(
  null,
  mapDispatchToProps,
)(Component);
